module.exports = __webpack_public_path__ + "img/ICON1.6370c6fc.png";